
import { ref, watch, defineComponent } from 'vue';
import { getVideoPosterUrl } from './utils'

export default defineComponent({
  name: 'Preview',
  props: {
    url: { type: String }
  },
  setup(props) {

    const posterUrl = ref()

    watch(() => props.url, (val, oldVal) => {
      console.log('val: ', val);
      getVideoPosterUrl(props.url || '').then(url => {
        posterUrl.value = url
      })
    }, { immediate: true })
    
    return {
      posterUrl
    }
  }
})



